import { QueryParams } from "@faire/web/common/query-params/QueryParams";

export interface AppSignUpQueryParams {
  readonly email: string | undefined;
  readonly signUp: string | undefined;
  readonly product: string | undefined;
  readonly refP: string | undefined;
  readonly brand: string | undefined;
  readonly livestream: string | undefined;
  readonly faireMarket: string | undefined;
  readonly utmContent: string | undefined;
}

export function getSignUpParams(query: QueryParams): AppSignUpQueryParams {
  return {
    email: query.get("email") ?? undefined,
    signUp: query.get("signUp") ?? undefined,
    brand: query.get("brand") ?? undefined,
    product: query.get("product") ?? undefined,
    refP: query.get("refP") ?? undefined,
    livestream: query.get("livestream") ?? undefined,
    faireMarket: query.get("faireMarket") ?? undefined,
    utmContent: query.get("utm_content") ?? undefined,
  };
}
